import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Socket } from "components/socket";
import { getStorageKey } from "utils/storageHelpers";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(
    localStorage.getItem(getStorageKey("authToken"))
  );
  const [userId, setUserId] = useState(() => {
    const profile = JSON.parse(localStorage.getItem(getStorageKey("profile")));
    return profile?.id || null;
  });
  const navigate = useNavigate();

  const login = (authData) => {
    const { token, profile } = authData;
    localStorage.setItem(getStorageKey("authToken"), token);
    localStorage.setItem(getStorageKey("profile"), JSON.stringify(profile));
    setToken(token);
    setUserId(profile?.id || null);

    if (profile?.id) {
      Socket.connect();
      Socket.on("connect", () => {
        Socket.emit("joinUserRoom", profile.id);
      });
    }

    navigate("/dashboard");
  };

  const logout = () => {
    localStorage.removeItem(getStorageKey("authToken"));
    localStorage.removeItem(getStorageKey("profile"));
    setToken(null);
    setUserId(null);

    if (Socket.connected) {
      Socket.disconnect();
      Socket.removeAllListeners();
    }

    navigate("/auth/signin");
  };

  return (
    <AuthContext.Provider value={{ token, userId, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
